const url = (obj) => obj.breadcrumb.items[1].hrefTo;

module.exports = {
  url,
};
